import {getTradeCollectionPath, type TradeDb} from '@cp/model';
import {doc, DocumentReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export function getTradeDocRef(uid: string, tradeId: string): DocumentReference<TradeDb> {
  return doc(firebaseFirestore, getTradeCollectionPath(uid), tradeId) as DocumentReference<TradeDb>;
}
